import React, { PureComponent } from 'react';
import { inject, observer } from 'mobx-react';

export default class ScrollTop extends PureComponent {

  handleClick = () => {
     document.getElementById('line-central-column').scrollTop = 0;
     document.getElementById('divmain').scrollTop = 0;
  }

	render() {
		return(
			<div className="line-left-menu-up line-up" title="Наверх">
        <button className="line-left-menu-up-btn" onClick={this.handleClick}>
          <span className="line-sport-menu-item-ico line-left-menu-up-ico">
            <div>
               <span className="f-s-ico-arrow_buttom_1"></span>
            </div>
          </span>
          <div className="line-left-menu-up-text"> Наверх</div>
        </button>
      </div>
		)
	}
}
			


// WEBPACK FOOTER //
// ./src/components/scrollTopButton/index.js